import React, { PureComponent } from 'react';
import axios from 'axios';
import { Row, Col } from 'react-bootstrap';
import Pagination from "react-js-pagination";
import UsersRowTable from './usersList/usersRowTable';
import UserEditModal from './usersList/userEditModal';
import UserDeleteModal from './usersList/userDeleteModal';
import ModalComponent from '../../components/complex/modalComponent';
import appConstant from '../../../constants/app';
import actionsConstant from '../../../constants/actions';

class UsersList extends PureComponent {
  state = {
    users: [],
    totalItems: null,
    isActive: false,
    body: '',
    activePage: 1,
    itemsCountPerPage: 15,
    pageRangeDisplayed: 5,
    isLoaderOpened: false,
    showPagination: false,
  }

  componentDidMount () {
    this.props.onRef(this);
    this.fetch(1);
  }

  componentWillUnmount() {
    this.props.onRef(undefined);
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.keyword !== this.props.keyword) {
      this.setState({activePage: 1});
      this.fetchSearch(this.props.keyword, 1);
    }
  }
  
  fetch = (page) => {
    this.setState({ isLoaderOpened: true });

    let url = `${appConstant.API_URL}/user?page=${page}&access_token=${localStorage.getItem('token')}`;
    axios.get(url)
      .then(res => {
        const totalItems = res.data.totalItems;
        const users = res.data.users;
        const showPagination = (totalItems > this.state.itemsCountPerPage);
        this.setState({
          users,
          totalItems,
          showPagination,
        });

        this.setState({ isLoaderOpened: false });
        this.props.updateSearchBar();
      }).catch(err => {
        console.log(err);
      });
  }

  fetchSearch = (key, page) => {
    let url = `${appConstant.API_URL}/user/search?key=${key}&page=${page}&access_token=${localStorage.getItem('token')}`;
    axios.get(url)
      .then(res => {
        const totalItems = res.data.totalItems;
        const users = res.data.users;
        const showPagination = (totalItems > this.state.itemsCountPerPage);
        this.setState({
          users,
          totalItems,
          showPagination,
        });
      }).catch(err => {
        const users = [];
        this.setState({
          users,
        });
      });
  }

  onToggleModal = () => {
    this.setState(prevState => ({ isActive: !prevState.isActive }));
  }

  onAccept = () => {
    this.fetch(1);
    this.setState({ activePage: 1 });
  }
  
  onHandleModal = (id, name, action) => {
    this.setState({id});
    this.onToggleModal();

    if(action === actionsConstant.edit) {
      this.setState({
        body: <UserEditModal
          id={id}
          onClose={this.onToggleModal}
          onAccept={this.onAccept}
        />,
        title: 'Edit user',
      });
    } else if(action === actionsConstant.delete) {
      this.setState({
        body: <UserDeleteModal
          id={id}
          name={name}
          onClose={this.onToggleModal}
          onAccept={this.onAccept}
        />,
        title: 'Are you sure you want to delete this user?',
      });
    }
  }

  handlePageChange = (pageNumber) => {
    this.setState({activePage: pageNumber});
    if(this.props.keyword) {
      this.fetchSearch(this.props.keyword, pageNumber);
    } else {
      this.fetch(pageNumber);
    }
  }

  render () {
    const {
      users,
      isActive,
      body,
      title,
      totalItems,
      itemsCountPerPage,
      pageRangeDisplayed,
      isLoaderOpened,
      showPagination,
    } = this.state;

    return (
      <div>
        <Row>
          <Col sm={12}>
          {
            isLoaderOpened
            ? <p> Loading... </p>
            : <UsersRowTable
              users={users}
              showModalHandle={this.onHandleModal}
            />
          }
          </Col>
        </Row>
        {
          showPagination
          ?
          <Row>
            <Col
              className="pagination-container"
              sm={12
            }>
              <Pagination
                activePage={this.state.activePage}
                totalItemsCount={totalItems}
                itemsCountPerPage={itemsCountPerPage}
                pageRangeDisplayed={pageRangeDisplayed}
                onChange={this.handlePageChange}
              />
            </Col>
          </Row>
          :
          <Row>
          </Row>
        }
        <ModalComponent
          isActive={isActive}
          onClose={this.onToggleModal}
          title={title}
          body={body}
        />
      </div>
    );
  }
}

export default UsersList;


// WEBPACK FOOTER //
// ./src/app/screens/users/usersList.js